import { useNavigate } from 'react-router-dom';
import './Information.css'; // Import CSS hanya untuk halaman ini

const Information = () => {
  const navigate = useNavigate();

  const handleProceed = () => {
    navigate("/signup");
  };

  return (
    <div className="information-container">
      <div className="card">
        <h1>Ketentuan dan Langkah untuk Mengisi Kuesioner Business Health Check-Up</h1>
        <p>
          Untuk memastikan bahwa Anda mengisi kuesioner business health check-up memahami tujuan, manfaat, 
          dan cara mengisi kuesioner dengan jelas, berikut adalah beberapa ketentuan dan langkah yang perlu diikuti:
        </p>

        <h2>Tujuan</h2>
        <p>
          1. <strong>Evaluasi Kesehatan Perusahaan:</strong> Tujuan utama dari kuesioner ini adalah untuk mengevaluasi 
          berbagai aspek penting dari perusahaan untuk mendapatkan gambaran yang komprehensif tentang kondisi kesehatan bisnis saat ini.
        </p>
        <p>
          2. <strong>Identifikasi Area Perbaikan:</strong> Mengidentifikasi area yang memerlukan perbaikan atau peningkatan 
          untuk memastikan bahwa perusahaan beroperasi secara efisien dan efektif.
        </p>
        <p>
          3. <strong>Perencanaan Strategis:</strong> Membantu perusahaan dalam merencanakan strategi jangka panjang dengan 
          data yang akurat dan relevan.
        </p>

        <p><strong>Are You Ready?</strong></p>
        <button onClick={handleProceed}>Let's Play</button>
      </div>
    </div>
  );
};

export default Information;
